import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import {
  AssistanceCost,
  FundingSource,
  KpiIndicatorsResponse,
  SectorCost,
} from '../../models/kpi.interface';
import { HttpClient, HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  constructor(private http: HttpClient) {}

  apiUrlCs = environment.service_1 + 'sector-cost-by-term-kpi/';
  apiUrlFs = environment.service_1 + 'founding-by-month-kpi/';
  apiUrlAc = environment.service_1 + 'assistence-cost-kpi/';
  apiUrlKi = environment.service_1 + 'general-indicators-kpi/';

  getCostsBySector(sector: string) {
    const params = new HttpParams().set('sector', sector);
    return this.http.get<SectorCost[]>(`${this.apiUrlCs}`, { params });
  }

  getFundingSources(sector: string) {
    const params = new HttpParams().set('sector', sector);
    return this.http.get<FundingSource[]>(`${this.apiUrlFs}`, { params });
  }

  getCostsByAssistance(sector: string) {
    const params = new HttpParams().set('sector', sector);
    return this.http.get<AssistanceCost[]>(`${this.apiUrlAc}`, { params });
  }

  getKpiIndicators(sector: string) {
    const params = new HttpParams().set('sector', sector);
    return this.http.get<KpiIndicatorsResponse>(`${this.apiUrlKi}`, { params });
  }
}
